var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GChart',{attrs:{"settings":{packages: ['bar']},"data":_vm.chartData,"options":_vm.chartOptions,"createChart":function (el, google) { return new google.charts.Bar(el); }},on:{"ready":_vm.onChartReady}})}
var staticRenderFns = []

export { render, staticRenderFns }